import React, { FC, PropsWithChildren } from 'react';
import { useDiffValueClass, useFieldDiff, useGroupDiff } from '~/hooks/useDraftDiffContext';

interface Props {
  source?: string;
  /** Marks the element when anything below the path differs; `true` takes the surrounding scope. */
  group?: string | true;
}

/**
 * For values `components/ra/TextField` cannot tint on its own — those passed as
 * children, and opaque widgets covered by `group`.
 */
const DiffHighlight: FC<PropsWithChildren<Props>> = ({ source, group, children }) => {
  const fieldDiff = useFieldDiff(source);
  const subtreeDiff = useGroupDiff(group === true ? undefined : group);
  const diff = group === undefined ? fieldDiff : subtreeDiff;

  const className = useDiffValueClass(diff);

  return <div className={className}>{children}</div>;
};

export default DiffHighlight;
